import axios from 'axios';


interface AxiosInstanceConfig {
  baseURL: string;
  timeout?: number;
  isFileUpload?: boolean;
  responseType?: 'json' | 'blob';
}

const eventEmitter = new EventTarget();

// Function to create an Axios instance
function createAxiosInstance({ isFileUpload = false, baseURL, timeout = 60000, responseType = 'json' }: AxiosInstanceConfig) {
  // Create an Axios instance
  const axiosInstance = axios.create({
    baseURL,
    timeout,
    responseType,
    headers: {
      'Content-Type': isFileUpload ? 'multipart/form-data' : 'application/json',
      'Accept': 'application/json'
    }
  });


  axiosInstance.interceptors.request.use(
    (config:any) => {
      const token = localStorage.getItem('app_identifier');

      if (token && config?.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error:any) => Promise.reject(error)
  );



  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        eventEmitter.dispatchEvent(new Event('logout'));
        console.error('Unauthorized request. Please log in again.');
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
}


const fileUploadInstance = createAxiosInstance({
  baseURL: process.env.REACT_APP_BASE_URL || '',
  isFileUpload: true,
});

const apiInstance = createAxiosInstance({
  baseURL: process.env.REACT_APP_BASE_URL || '',
});

const fileDownloadInstance = createAxiosInstance({
  baseURL: process.env.REACT_APP_BASE_URL || '',
  responseType: 'blob',
});

export {fileUploadInstance,  apiInstance, fileDownloadInstance, eventEmitter  };
